import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../../Apanel/QueryMe';
import Switch from 'react-switch';
import Select from 'react-select';
var dateFormat = require('dateformat');
import {
	Button,
	ButtonGroup,
	ButtonToolbar,
	Card,
	CardBody,
	Col,
	Badge,
	Table,
	Modal,
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import Alert from '../../../../shared/components/Alert';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	image: dimgurl,
	alltickets: [],
	showAlert: false,
	alertType: '',
	alertText: '',
	token: localStorage.token,
	title: '',
	description: '',
	ticketid: localStorage.ticketid,
	priority: 'low',
};
const priorityOptions = [
	{ value: 'high', label: 'High' },
	{ value: 'medium', label: 'Medium' },
	{ value: 'low', label: 'Low' },
];
class Viewticket extends Component {
	constructor(props) {
		super(props);
		this.handlePriorityChange = this.handlePriorityChange.bind(this);
	}
	state = { ...initialstate };
	componentDidMount() {
		this.handleGetTicket(localStorage.token);
		console.log('ticketid', localStorage.ticketid);
	}
	handleChange = (event) => {
		const { name, value } = event.target;
		console.log(name + ' ' + value);
		this.setState({ [name]: value });
	};
	handlePriorityChange(event) {
		this.setState(
			{
				priority: event.value,
			},
			() => {
				console.log('priority', this.state.priority);
			},
		);
	}
	handleno = (id) => {
		console.log(id);
		return;
	};
	handleAkey = () => {
		this.setState({
			addTicketModal: true,
		});
	};

	handleUserSubmit = (event) => {
		event.preventDefault();
		console.log(this.state.title);
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		const upticketurl = apiurl + 'updateticket';
		var postData = {
			ticketid: this.state.ticketid,
			reply: this.state.description,
			uid: localStorage.usercode,
		};
		axios
			.post(upticketurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
					});
				} else {
					swal(' Ticket ' + response.data.message, {
						icon: 'success',
					});
					this.setState(
						{
							addTicketModal: false,
							showAlert: false,
							reply: '',
							priority: '',
						},
						() => {
							this.handleGetTicket(localStorage.token);
						},
					);
				}
			})
			.catch((error) => {
				console.log('Error is ', error);
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failed Try Again Later!',
				});
			});
	};
	handleCkey = () => {
		this.setState({
			addTicketModal: false,
		});
	};
	handleTicket = (id, all) => {
		console.log(id);
		localStorage.setItem('ticketid', '');
		this.props.history.push('/recruiter/mytickets', {
			ticketid: '',
		});
	};
	handleTkey = (id, ttitle, checked) => {
		// console.log(checked + 'checked');
		// console.log(id + 'id');
		// console.log(ttitle + 'ttitle');
		var keysts = checked == true ? 0 : 1;
		var kstatus = 'Close';
		if (checked) {
			kstatus = 'Reopen';
		}
		swal({
			title: kstatus + ' ' + ttitle,
			text: 'Are you sure?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((keyconfirm) => {
			if (keyconfirm) {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const toticketurl = apiurl + 'togticket';
				var postData = {
					uid: localStorage.usercode,
					ticketid: id,
					tstatus: keysts,
				};
				axios
					.post(toticketurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);

						if (response.data.error) {
							swal(ttitle + ' ' + response.data.message, {
								icon: 'warning',
							});
						} else {
							this.handleGetTicket(localStorage.token);
							swal(ttitle + ' ' + response.data.message, {
								icon: 'success',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						swal('Try Again Later', {
							icon: 'Danger',
						});
					});
			}
		});
	};
	handleGetTicket = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
			uid: localStorage.usercode,
			ticketid: this.state.ticketid,
		};
		const getuurl = apiurl + 'getoneticket';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					console.log(response.data.data[0]);
					this.setState({
						alltickets: [response.data.data],
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};

	render() {
		const {
			addTicketModal,
			showAlert,
			alertType,
			alertText,
			showtickets,
			title,
			description,
			priority,
		} = this.state;
		return (
			<Col md={12}>
				<div className="panel panel--success card">
					<div className="panel__body card-body">
						<div className="panel__title">
							<h5 className="bold-text">
								Success panel
								<span className="panel__label badge badge-secondary"></span>
							</h5>
							<h5 className="subhead"></h5>
						</div>
						<div className="collapse show">
							<div className="panel__content">
								<p className="typography-message">
									Folly words widow one downs few age every seven. If miss part
									by fact he park just shew. Discovered had get considered
									projection who favourable. Necessary up knowledge it
									tolerably. Unwilling departure education is be dashwoods or
									an. Use off agreeable law unwilling sir deficient curiosity
									instantly.
								</p>
							</div>
						</div>
					</div>
				</div>
				<Card>
					<CardBody>
						<div className="card__title">
							<h5 className="bold-text">
								Ticket Title:
								<Button
									className="float-right btn-sm"
									color="success"
									onClick={this.handleAkey}
								>
									+
								</Button>
							</h5>
						</div>

						<Table responsive hover>
							<thead>
								<tr>
									<th>#</th>
									<th>Status</th>
									<th>Title</th>
									<th>Date</th>
									<th>Manage</th>
								</tr>
							</thead>
							<tbody>
								{this.state.alltickets &&
									this.state.alltickets.map((ticket, index) => {
										var usts = true;
										if (ticket.status === 1) {
											usts = false;
										}
										if (ticket.status == showtickets) {
											return (
												<tr key={index}>
													<td>{index + 1}</td>

													<td>
														<Switch
															handleDiameter={10}
															height={15}
															checked={usts}
															onChange={this.handleno.bind(this)}
														/>
													</td>
													<td>{ticket.title}</td>

													<td>{dateFormat(ticket.createdon, 'd-m-yyyy')}</td>
													<td>
														<Button
															className="float-right btn-sm smallbtn"
															color="success"
															onClick={this.handleTicket.bind(this, ticket.id)}
														>
															View
														</Button>
													</td>
												</tr>
											);
										}
									})}
							</tbody>
						</Table>
						<Modal
							isOpen={this.state.addTicketModal}
							modalClassName="ltr-support"
							className="modal-dialog--primary newt"
						>
							<div className="modal__header">
								<button
									className="lnr lnr-cross modal__close-btn"
									type="button"
									onClick={this.handleCkey}
								/>
								<h4 className="text-modal  modal__title">Add New Ticket</h4>
							</div>
							<div className="modal__body">
								{this.state.showAlert ? (
									<Alert color={this.state.alertType}>
										<p>{this.state.alertText}</p>
									</Alert>
								) : null}
								<form
									className="form"
									onSubmit={(event) => this.handleUserSubmit(event)}
								>
									<div className="form__form-group">
										<div className="form__form-group-field">
											<input
												name="title"
												type="text"
												placeholder="Enter Title"
												className="form-control"
												value={title}
												onChange={this.handleChange}
												required
											/>
										</div>
									</div>
									<div className="form__form-group">
										<div className="form__form-group-field">
											<textarea
												name="description"
												type="text"
												placeholder="Enter Description"
												className="form-control"
												value={description}
												onChange={this.handleChange}
												required
											/>
										</div>
									</div>
									<div className="form__form-group">
										<span className="form__form-group-label">Priority</span>
										<div className="form__form-group-field priority">
											<Select
												options={priorityOptions}
												onChange={this.handlePriorityChange}
												defaultValue={priority}
											/>
										</div>
									</div>
									<button
										className="btn btn-primary account__btn account__btn--small"
										type="submit"
									>
										Add Ticket
									</button>
								</form>
							</div>
						</Modal>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default Viewticket;
